import React from "react";
import styles from "./styles/PlasticMoulding.module.css";
import Header from "../../shared/Header/Header";
import Footer from "../../shared/Footer/Footer";
import PlasticMouldingHero from "./PlasticMouldingHero";
import PlasticMouldingContent from "./PlasticMouldingContent";
import PlasticMouldingCTA from "./PlasticMouldingCTA";

export default function PlasticMoulding() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PlasticMouldingHero />
        <PlasticMouldingContent />
        <PlasticMouldingCTA />
      </main>
      <Footer />
    </div>
  );
}
